import { Component, signal, OnInit } from '@angular/core';

import { environment } from '../environments/environment';
import { Header } from './components/header/header';
import { BenefitsCards } from './pages/landing-page/benefits-cards/benefits-cards';
import { WhyChooseUs } from './components/why-choose-us/why-choose-us';
import { ProjectInfo } from './pages/landing-page/project-info/project-info';
import { PhotoGallery } from './components/photo-gallery/photo-gallery';
import { InteractiveMap } from './components/interactive-map/interactive-map';
import { Footer } from './components/footer/footer';
import { Loader } from './components/loader/loader';
import { VideoModal } from './components/video-modal/video-modal';
import { WhatsAppFloat } from './components/whatsapp-float/whatsapp-float';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [Header, BenefitsCards, WhyChooseUs, ProjectInfo, PhotoGallery, InteractiveMap, Footer, Loader, VideoModal, WhatsAppFloat],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  s3BaseUrl = environment.s3BaseUrl;
  protected readonly title = signal('La Joya Park Resort');
  isGalleryOpen = false;
  isLoading = true;
  isVideoModalOpen = false;

  toggleGallery() {
    this.isGalleryOpen = !this.isGalleryOpen;
  }

  openGallery() {
    this.isGalleryOpen = true;
  }

  closeGallery() {
    this.isGalleryOpen = false;
  }

  openVideoModal() {
    this.isVideoModalOpen = true;
  }

  closeVideoModal() {
    this.isVideoModalOpen = false;
  }

  ngOnInit() {
    // Simular tiempo de carga (ajustar según necesidades)
    setTimeout(() => {
      this.isLoading = false;
    }, 2500); // 2.5 segundos
  }

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
